import React from 'react';
import Field from '../../shared/ui/Field';
import {
  useFieldController,
  useFormMethods,
} from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import {
  useIntervalTypesQuery,
  intervalTypesSelectors,
} from '../../api/intervalTypes';
import { defaultIntervalTypeId } from '../../shared/configs/selectionData/intervalTypes';
import { useEvent } from '../../../../hooks/useEvent';

const {
  intervalType: createIntervalTypeName,
  scheduleSettings: createScheduleSettingsName,
} = fieldPathBuilders.desk;

const SelectDeskIntervalType = ({ deskIndex, className, disabled }) => {
  const {
    field: { value, onChange },
  } = useFieldController({
    name: createIntervalTypeName(deskIndex),
    defaultValue: defaultIntervalTypeId,
  });

  const { data: types } = useIntervalTypesQuery({
    options: { select: intervalTypesSelectors.toOptions },
  });

  const { unregister } = useFormMethods();

  const handleChange = useEvent((value) => {
    onChange(value);
    unregister(createScheduleSettingsName(deskIndex));
  });

  return (
    <Field.Memoized
      type={Field.types.dropdownSelect}
      value={value}
      onChange={handleChange}
      options={types}
      multiple={false}
      label="Настройка интервалов"
      rootCN={className}
      disabled={disabled}
    />
  );
};

export default SelectDeskIntervalType;
